import React from 'react';
import HeadlineWithFocus from "../../components/HeadlineWithFocus";
import styled from 'styled-components';
import { Page, Row, Column } from 'hedron';
import ColorBar from '../../components/colorbar';
import ProfileImage from '../../assets/images/apps/SLaMAf/logo.png';
import SLaMAf from '../../assets/images/apps/SLaMAf/SLaMAfimage.png';
import typeandcheck from '../../assets/images/apps/SLaMAf/updatePlots.png';
import forcedrift from '../../assets/images/apps/bcj/forcedrift.png';
import hierarchy from '../../assets/images/apps/bcj/hierarchy.png';
import plasticMech from '../../assets/images/apps/SLaMAf/plasticMechanism.png';
import capCurve from '../../assets/images/apps/SLaMAf/capCurve.png';
import license from '../../assets/images/apps/bcj/license.png';
import Form from '../../components/contact/index.en';
import DownloadIcon from '../../assets/images/download.png';
import ScrollableAnchor from 'react-scrollable-anchor';
import ResponsiveEmbed from "react-responsive-embed";



const ImageWrapper = styled.div.attrs({

  image: props => props.image
})`
  background-image: url(${props => props.image});
  background-size: 100%;
  @media (min-width: 300px) {
    background-position: center;
    background-repeat: no-repeat;
    height: 450px;
  }
`

const DownloadIconContainer = styled.div`
	position: fixed;
	zIndex: 999;
	background-image: url(${DownloadIcon});
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
  @media (max-width: 299px) {
    right: 10%;
    bottom: 0%;
    width: 20%;
    height: 20%;
  }
  @media (min-width: 300px) {
    right: 10%;
    bottom: 0%;
    width: 15%;
    height: 15%;
  }
  @media (min-width: 600px) {
    right: 7%;
    bottom: 2%;
    width: 12%;
    height: 12%;
  }
  @media (min-width: 1100px) {
    right: 2%;
	  bottom: 2%;
	  width: 15%;
	  height: 15%;
	}

`

const ImgColStyle = {
  padding: '0',
};


const RowStyleEVEN = {
  background: '#F9F9F9',
};

const RowStyleODD = {
  background: '#F5F5F5',
};


const About = props => {
    return (
		<div>
			<a href="#download">
				<DownloadIconContainer />
			</a>
			<Row alignItems="center" style={RowStyleEVEN}>
				<Column xs={12} sm={12} smShift={0} md={6} lg={4}  style={ImgColStyle}>
				   <ImageWrapper image={ProfileImage} />
				</Column>
				<Column xs={12} sm={12} smShift={0} md={6} lg={8}>
          <h1><u style={{textDecoration: 'none', borderBottom: '10px solid #DFAB50'}}>SLaMA Solver Frame</u></h1>
				  <h3><p>
          The Simple Lateral Mechanism Analysis (SLaMA) allows to estimate both the plastic mechanism and the capacity curve (i.e. a force–displacement curve) of reinforced concrete frames (among others). SLaMA Solver Frame provides a graphical user interface to apply SLaMA.
          </p></h3>
				</Column>
			</Row>

      <Row alignItems="center" style={RowStyleODD}>
        <Column xs={12} sm={12} smShift={0} md={6} lg={4}  style={ImgColStyle}>
           <ImageWrapper image={SLaMAf} />
        </Column>
				<Column xs={12} sm={12} smShift={0} md={6} lg={8}>
                    <h1><u style={{textDecoration: 'none', borderBottom: '12px solid #A661C2'}}>Completely standalone</u><br />
                    </h1>
				  <h3><p>
				  	You don’t need any other software to run it
				  </p></h3>
				</Column>
			</Row>

      <Row alignItems="center" style={RowStyleEVEN}>
				<Column xs={12} sm={12} smShift={0} md={6} lg={4}  style={ImgColStyle}>
				   <ImageWrapper image={typeandcheck} />
				</Column>
				<Column xs={12} sm={12} smShift={0} md={6} lg={8}>
                    <h1><u style={{textDecoration: 'none', borderBottom: '12px solid #DFAB50'}}>Type and Check Environment</u></h1>
				  <h3><p>Every time you input a parameter, a plot updates allowing for cross checks</p></h3>
				</Column>
			</Row>

      <Row alignItems="center" style={RowStyleODD}>
				<Column xs={12} sm={12} smShift={0} md={6} lg={4}  style={ImgColStyle}>
				   <ImageWrapper image={forcedrift} />
				</Column>
        <Column xs={12} sm={12} smShift={0} md={6} lg={8}>
          <h1><u style={{textDecoration: 'none', borderBottom: '12px solid #A661C2'}}>Member failure mode</u></h1>
				  <h3><p>For each beam and column, SLaMA solver Frame provides their expected failure mode: flexure, bar buckling, shear, lap splice</p></h3>
				</Column>
			</Row>

      <Row alignItems="center" style={RowStyleEVEN}>
				<Column xs={12} sm={12} smShift={0} md={6} lg={4}  style={ImgColStyle}>
				   <ImageWrapper image={hierarchy} />
				</Column>
				<Column xs={12} sm={12} smShift={0} md={6} lg={8}>
                    <h1><u style={{textDecoration: 'none', borderBottom: '12px solid #DFAB50'}}>Hierarchy of strength</u></h1>
				  <h3><p>For each beam column joint sub-assembly, SLaMA Solver Frame determines its hierarchy of strength, indicating the member-level mechanism that causes its failure</p></h3>
				</Column>
			</Row>

      <Row alignItems="center" style={RowStyleODD}>
				<Column xs={12} sm={12} smShift={0} md={6} lg={4}  style={ImgColStyle}>
				   <ImageWrapper image={plasticMech} />
				</Column>
        <Column xs={12} sm={12} smShift={0} md={6} lg={8}>
          <h1><u style={{textDecoration: 'none', borderBottom: '12px solid #A661C2'}}>Plastic mechanism</u></h1>
				  <h3><p>By composing the results of each sub-assembly, SLaMA solver Frame provides an estimation of the plastic mechanism</p></h3>
				</Column>
			</Row>

      <Row alignItems="center" style={RowStyleEVEN}>
				<Column xs={12} sm={12} smShift={0} md={6} lg={4}  style={ImgColStyle}>
				   <ImageWrapper image={capCurve} />
				</Column>
				<Column xs={12} sm={12} smShift={0} md={6} lg={8}>
                    <h1><u style={{textDecoration: 'none', borderBottom: '12px solid #DFAB50'}}>Global capacity curve</u></h1>
				  <h3><p>The results are composed to derive a force-displacement capacity curve (pushover) for three different plastic mechanisms: Beam Sway, Mixed Sway and Column Sway</p></h3>
				</Column>
			</Row>

      <Row alignItems="center" style={RowStyleODD}>
				<Column xs={12} sm={12} smShift={0} md={6} lg={4}  style={ImgColStyle}>
				   <ImageWrapper image={license} />
				</Column>
        <Column xs={12} sm={12} smShift={0} md={6} lg={8}>
            <h1><u style={{textDecoration: 'none', borderBottom: '12px solid #A661C2'}}>License</u></h1>
				  <h3><p>Creative commons “Attribution-No Derivatives 4.0 International” license</p></h3>
				</Column>
			</Row>

      <Row alignItems="center" style={RowStyleEVEN}>
				<Column xs={12} sm={12} smShift={0} md={6} lg={4}  style={ImgColStyle}>
				   <ResponsiveEmbed src='https://www.youtube.com/embed/_s6Hbr0A0ZA' allowFullScreen />
				</Column>
        <Column xs={12} sm={12} smShift={0} md={6} lg={8}>
            <h1><u style={{textDecoration: 'none', borderBottom: '12px solid #DFAB50'}}>In action</u></h1>
				  <h3><p>Watch this simple video tutorial</p></h3>
				</Column>
			</Row>

      <Row>
				<ScrollableAnchor id={'download'}>
          <Column xs={12} sm={12} smShift={0} md={10} mdShift={1} lg={8} lgShift={2}>
            <Form formName="SLaMAf" />
					</Column>
				</ScrollableAnchor>
      </Row>
		</div>
	)
}

export default About;



// WEBPACK FOOTER //
// ./src/pages/SLaMAf/index.en.jsx